import apiClient from '../../../common/services/apiClient';
import { createQueryString, removeFalsyProperties } from '../../../common/utils/helpers';
import { impersonateUser } from '../ducks/index';

export const apiCallIds = {
  FETCH_ACCOUNTS: 'FETCH_ACCOUNTS',
  FETCH_ACCOUNT: 'FETCH_ACCOUNT',
  FETCH_SAME_INSTALL_ACCOUNTS: 'FETCH_SAME_INSTALL_ACCOUNTS',
  FETCH_ACCOUNT_DEVICES: 'FETCH_ACCOUNT_DEVICES',
  IMPERSONATE_USER: 'IMPERSONATE_USER',
  UPDATE_ACCOUNT: 'UPDATE_ACCOUNT',
  UPDATE_ACCOUNT_PROFILE: 'UPDATE_ACCOUNT_PROFILE',
  FETCH_ACCOUNT_DOCUMENTS: 'FETCH_ACCOUNT_DOCUMENTS',
  UPDATE_ACCOUNT_DOCUMENTS: 'UPDATE_ACCOUNT_DOCUMENTS',
  ACCEPT_ACCOUNT_DOCUMENTS: 'ACCEPT_ACCOUNT_DOCUMENTS',
  REJECT_ACCOUNT_DOCUMENTS: 'REJECT_ACCOUNT_DOCUMENTS',
  CREATE_ADMINISTRATOR: 'CREATE_ADMINISTRATOR',
  FETCH_ACCOUNT_MESSAGES: 'FETCH_ACCOUNT_MESSAGES',
  FETCH_ACCOUNT_ALL_MESSAGES: 'FETCH_ACCOUNT_ALL_MESSAGES',
  FETCH_ID_CARD_INFO: 'FETCH_ID_CARD_INFO',
  FETCH_ACCOUNT_UPDATE_LOGS: 'FETCH_ACCOUNT_UPDATE_LOGS',
  FETCH_FEE_ACCOUNT_AMOUNT: 'FETCH_FEE_ACCOUNT_AMOUNT',
  CHECK_GENERAL_CONTRACT_DATE: 'CHECK_GENERAL_CONTRACT_DATE',
  SAVE_VERIFICATION_RESULT: 'SAVE_VERIFICATION_RESULT',
};

export default {
  fetchAccounts: options => {
    return apiClient.get(`/account?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_ACCOUNTS,
    });
  },

  fetchAccount: accountId => {
    return apiClient.get(`/account/${accountId}`, {
      apiCallId: apiCallIds.FETCH_ACCOUNT,
    });
  },

  fetchSameInstallAccounts: accountId => apiClient.get(`/account/${accountId}/same-install-accounts`, {
    apiCallId: apiCallIds.FETCH_SAME_INSTALL_ACCOUNTS,
  }),

  fetchAccountDevices: accountId => apiClient.get(`/account/${accountId}/devices`, {
    apiCallId: apiCallIds.FETCH_ACCOUNT_DEVICES,
  }),

  impersonateUser: (adminId, userId) => {
    return apiClient.post(`/auth/impersonate`, {adminId, userId}, {apiCallId: apiCallIds.IMPERSONATE_USER});
  },

  updateAccount: (accountId, accountData) => {
    return apiClient.put(`/account/${accountId}`, removeFalsyProperties(accountData), {
      apiCallId: apiCallIds.UPDATE_ACCOUNT,
    });
  },

  updateAccountProfile: (accountId, profileData, employersData, loanObligations) => {

    const payload = { profileData: removeFalsyProperties(profileData), employersData: removeFalsyProperties(employersData) }
    if (Array.isArray(loanObligations)) {
      payload.loanObligations = loanObligations;
    }
    return apiClient.put(`/account/${accountId}/profile`, payload, {
      apiCallId: apiCallIds.UPDATE_ACCOUNT_PROFILE,
    });
  },

  fetchAccountDocuments: accountId => {
    return apiClient.get(`/account/${accountId}/document`, {
      apiCallId: apiCallIds.FETCH_ACCOUNT_DOCUMENTS,
    });
  },

  updateAccountDocuments: (accountId, documentsData) => {
    return apiClient.put(`/account/${accountId}/document`, documentsData, {
      apiCallId: apiCallIds.UPDATE_ACCOUNT_DOCUMENTS,
    });
  },

  submitAccountDocuments: accountId => {
    return apiClient.post(`/account/${accountId}/document/submit`, null);
  },

  acceptAccountDocuments: accountId => {
    return apiClient.post(`/account/${accountId}/document/confirm`, null, {
      apiCallId: apiCallIds.ACCEPT_ACCOUNT_DOCUMENTS,
    });
  },

  rejectAccountDocuments: (accountId, { rejectReason }) => {
    return apiClient.post(
      `/account/${accountId}/document/reject`,
      { rejectReason },
      { apiCallId: apiCallIds.REJECT_ACCOUNT_DOCUMENTS }
    );
  },

  createAdministrator: accountData => {
    return apiClient.post(`/account/administrator`, accountData, {
      apiCallId: apiCallIds.CREATE_ADMINISTRATOR,
    });
  },

  fetchAccountMessages: (accountId, options) => {
    return apiClient.get(`/account/${accountId}/messages?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_ACCOUNT_MESSAGES,
    });
  },

  fetchAccountAllMessages: (accountId) => {
    return apiClient.get(`/account/${accountId}/allMessages`, {
      apiCallId: apiCallIds.FETCH_ACCOUNT_MESSAGES,
    });
  },

  createAccountMessage: (accountId, messageData) => {
    return apiClient.post(`/account/${accountId}/message`, messageData);
  },

  fetchIdCardInfo: accountId => {
    return apiClient.put(`/account/${accountId}/idCardCheck`, null, {
      apiCallId: apiCallIds.FETCH_ID_CARD_INFO,
    });
  },

  fetchAccountUpdateLogs: accountId => {
    return apiClient.get(`/account/${accountId}/updateLogs`, {
      apiCallId: apiCallIds.FETCH_ACCOUNT_UPDATE_LOGS,
    });
  },

  fetchFeeAccountAmount: () => {
    return apiClient.get(`/feeAccountAmount`, {
      apiCallId: apiCallIds.FETCH_FEE_ACCOUNT_AMOUNT,
    })
  },

  checkGeneralContractDate : accountId => {
    return apiClient.get(`/account/${accountId}/checkContractDate`, {
      apiCallId: apiCallIds.CHECK_GENERAL_CONTRACT_DATE,
    })
  },

  saveVerificationResult: (accountId, verificationResult) => {
    return apiClient.post(`/account/${accountId}/saveVerificationResult`, verificationResult, {
      apiCallId: apiCallIds.SAVE_VERIFICATION_RESULT
    });
  }
};



// WEBPACK FOOTER //
// ./src/features/account-management/api/index.js